import React, { useState, useEffect } from "react";
import Snackbar from "../../../../common/Snackbar";
import SearchableSingleSelectDropdown from "../../../../common/SearchableDropdown";
import {
  addStackeholderAddress,
  searchZipCode,
  updateStackeholderAddress,
  StachHolderTypes,
} from "../../../../services/StakeholderApi";
import SearchHospitalAutosuggest, { LocationSuggestion } from "../../../../common/SearchHospitalAutosuggest";
import { addMedicareLocation } from "../../../../services/SystemLocationAPI";
import { fetchPickListByGroupName } from "../../../../services/UserRegistrationApi";
import { PICKLIST_GROUP_NAME } from "../../../../common/Constant";
import {
  normalizeState,
  normalizeCountry,
} from "../../../../utils/normalizer";
import { useSelector } from "react-redux";
import TextInput from "../../../../common/TextInput";
import { RootState } from "../../../../redux/Store";
import StackHolderAddressList from "./StackHolderAddressList";
import {
  Modal,
  Button,
  Row,
  Container,
  Col,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import OverlayDrawer from "../../../../common/OverlayDrawer";
import DataTable from "../../../../common/DataTable";
import moment from "moment";
import { STAKEHOLDER_LOG_ADDRESS } from "../actions/Constant";
import FormattedPhoneInput from "../../../../common/FormattedPhoneInput";
import AccordionComponent from "../../../../common/Accordion";
import { PARTIES_MASTER_ACTIONS } from "../../../../common/EventConstant";
import { isValidCoordinate } from "../../../../utils/validators";
interface Option {
  areaName?: string;
  localeName?: string;
  physicalCity?: string;
  physicalZip?: string;
  physicalState?: string;
  districtName?: string;
  country?: string;
}

interface AddNewStackHolderProps {
  userData: any;
  action: string;
  onAddressSaved: () => void; // Callback to refresh the list in the parent component
  handlefetchAddressData: () => void;
  SelectedUserData: any;
  onFormCancel: () => void;
}

interface ApiResponse {
  isSuccess: boolean;
  result: StakeholderResponse; // Assuming 'result' is the ID of the new address
}
interface StakeholderResponse {
  responseCode: number;
  id: number;
  message: string | null;
}
interface ConfirmationModalProps {
  show: boolean;
  handleClose: () => void;
  handleConfirm: () => void;
  message: string;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  show,
  handleClose,
  handleConfirm,
  message,
}) => {
  return (
    <Modal show={show} onHide={handleClose}>
      {/* <Modal.Header closeButton>
        <Modal.Title>Confirm Action</Modal.Title>
      </Modal.Header> */}
      <Modal.Body className="fw-bold text-left modelheading ">
        {message}
      </Modal.Body>
      <Modal.Footer className="border-0 d-flex justify-content-end">
        <Button
          variant="outline-info"
          className="d-flex align-items-center"
          onClick={handleClose}
        >
          <span className="material-icons mr-2">close</span> Cancel
        </Button>
        <Button
          variant="primary"
          className="ms-3 d-flex align-items-center"
          onClick={handleConfirm}
        >
          <span className="material-icons mx-1">check</span> Confirm
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const AddNewUser: React.FC<AddNewStackHolderProps> = ({
  userData,
  action,
  onAddressSaved,
  handlefetchAddressData,
  SelectedUserData,
  onFormCancel,
}) => {
  const [snackbarOpen, setSnackbarOpen] = useState<boolean>(false);
  const [snackbarMessage, setSnackbarMessage] = useState<string>("");
  const [error, setError] = useState<boolean>(false);
  const [isEditable, setIsEditable] = useState<boolean>(action === "edit");
  const [stakeholderTypeId, setStakeholderTypeId] = useState("");
  const loggedInUserid = useSelector((state: RootState) => state.auth.userid);
  const [stakeholderAddressId, setStakeholderAddressId] = useState("");
  const [showDetails, setShowDetails] = useState(false);
  const [createdon, setcreatedon] = useState("");
  const [addressDetails, setAddressDetails] = useState<any[]>([]);
  const [addressline1, setAddressLine1] = useState("");
  const [addressline2, setAddressLine2] = useState("");
  const [addressline3, setAddressLine3] = useState("");
  const [email, setEmail] = useState("");
  const [faxNumber, setFaxNumber] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [isPrimary, setIsPrimaryAddress] = useState(true);
  const [isActive, setIsActive] = useState(true);
  const [comments, setComments] = useState("");
  const [addressTypeID, setAddressTypeID] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("");
  const [county, setCounty] = useState("");
  const [stakeholderaddressid, setstakeholderaddressid] = useState("");
  const [createdby, setcreatedby] = useState("");
  const [modifiedby, setmodifiedby] = useState("");
  const [createddate, setcreateddate] = useState("");
  const [modifieddate, setmodifieddate] = useState("");
  const [stakeholderId, setStakeholderId] = useState(userData);
  const [showModal, setShowModal] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [suggestionSelected, setSuggestionSelected] = useState(false);
  const [suggestionFilled, setSuggestionFilled] = useState({ city: false, state: false, country: false, zipCode: false });
  const [pendingGoogleLocation, setPendingGoogleLocation] = useState<any>(null);
  const [instructionOption, setInstructionOption] = useState<
    { value: string; label: string }[]
  >([]);

  const [addressFormKey, setAddressFormKey] = useState<string | null>("0");

  const allowedFeatures = useSelector(
    (state: RootState) => state.featureAccess.allowedFeatures
  );

  const editContact = allowedFeatures.has(PARTIES_MASTER_ACTIONS.CONTACT_EDIT);

  useEffect(() => {
    if (SelectedUserData) {
      setAddressLine1(SelectedUserData.addressline1);
      setAddressLine2(SelectedUserData.addressline2);
      setAddressLine3(SelectedUserData.addressline3);
      setEmail(SelectedUserData.email);
      setFaxNumber(SelectedUserData.faxnumber);
      setPhoneNumber(SelectedUserData.phonenumber);
      setZipCode(SelectedUserData.zipcode);
      setIsPrimaryAddress(SelectedUserData.isprimaryaddress);
      setIsActive(SelectedUserData.isactive);
      setComments(SelectedUserData.comments);
      setAddressTypeID(String(SelectedUserData.addresstypeid));
      setState(SelectedUserData.state);
      setCity(SelectedUserData.city);
      setCountry(SelectedUserData.country);
      setCounty(SelectedUserData.country);
      setstakeholderaddressid(SelectedUserData.stakeholderaddressid);
      setcreatedby(SelectedUserData.createdbyname);
      setmodifiedby(SelectedUserData.modifiedbyname);
      const formattedCreatedDate = moment(SelectedUserData.createddate).format(
        "MM/DD/YYYY hh:mm A"
      );
      const formattedModifiedDate = moment(
        SelectedUserData.modifieddate
      ).format("MM/DD/YYYY hh:mm A");
      setcreateddate(formattedCreatedDate);
      setmodifieddate(formattedModifiedDate);
      setAddressDetails([
        {
          createdby,
          createddate,
          modifiedby,
          modifieddate,
        },
      ]);
    }
  }, [action, SelectedUserData]);

  const [searchQuery, setSearchQuery] = useState<string>("");
  const [typeOption, setTypeOption] = useState<
    { value: string; label: string }[]
  >([]);

  const fetchInstructionOptions = async () => {
    try {
      const data = await fetchPickListByGroupName({
        groupName: PICKLIST_GROUP_NAME.Location_SplInstructions,
        triggerById: loggedInUserid,
      });
      setInstructionOption(data || []);
    } catch (error) {
      console.error("Error fetching instruction options:", error);
    }
  };

  useEffect(() => {
    const fetchDropdownOptions = async () => {
      try {
        const response = await StachHolderTypes({
          groupName: "Address_Type",
          triggerById: Number(loggedInUserid),
        });

        const formattedOptions = response.result.map((item: any) => ({
          value: String(item.pickListItemId),
          label: item.displayName,
        }));

        setTypeOption(formattedOptions);

        // ✅ Find the one with label "commercial/business" and set it
        const defaultOption = formattedOptions.find(
          (item) =>
            item.label.toLowerCase() === "Commercial/Business".toLowerCase()
        );

        if (defaultOption) {
          setAddressTypeID(defaultOption.value);
        }
      } catch (error) {
        console.error("Error fetching stakeholder types:", error);
      }
    };

    fetchDropdownOptions();
    fetchInstructionOptions();
  }, [loggedInUserid]);

  const handleSuggestionSelect = async (suggestion: LocationSuggestion) => {
    const newStateCode = suggestion.physicalStateCode || normalizeState(suggestion.physicalState || "");
    const newCountryCode = normalizeCountry(suggestion.countryCode || suggestion.country || "USA");

    setAddressLine1(suggestion.providerAddress || suggestion.providerName || "");
    setCity(suggestion.physicalCity || "");
    setState(newStateCode);
    setCountry(newCountryCode);
    setZipCode(suggestion.physicalZip || "");
    setSuggestionSelected(true);
    setSuggestionFilled({
      city: !!suggestion.physicalCity,
      state: !!newStateCode,
      country: !!newCountryCode,
      zipCode: !!suggestion.physicalZip,
    });

    if (suggestion.source === "google") {
      setPendingGoogleLocation({
        source: "google",
        providerName: suggestion.providerName,
        providerAddress: suggestion.providerAddress,
        physicalCity: suggestion.physicalCity,
        physicalState: newStateCode,
        physicalZip: suggestion.physicalZip,
        countryName: newCountryCode,
        providerType: "Medicare",
        latitude: isValidCoordinate(suggestion.latitude) ? String(suggestion.latitude) : "",
        longitude: isValidCoordinate(suggestion.longitude) ? String(suggestion.longitude) : "",
        county: suggestion.county,
        areaName: suggestion.areaName || "",
      });
    } else {
      setPendingGoogleLocation(null);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    if (isSaving) return;
    e.preventDefault();
    const errors: string[] = [];

    if (!addressline1) errors.push("Address Line #1 is mandatory.");
    if (!city) errors.push("City is mandatory.");
    if (!state) errors.push("State is mandatory.");
    if (!country) errors.push("Country is mandatory.");
    if (!zipCode) errors.push("Zip Code is mandatory.");
    if (!phoneNumber) {
      errors.push("Phone number is mandatory.");
    } else if (phoneNumber) {
      const phoneRegex = /^\d{3}-\d{3}-\d{4}$/;
      if (!phoneRegex.test(phoneNumber)) {
        errors.push("Phone number is invalid.");
      }
    }
    if (faxNumber) {
      const phoneRegex = /^\d{3}-\d{3}-\d{4}$/;
      if (!phoneRegex.test(faxNumber)) {
        errors.push("Fax No is invalid.");
      }
    }
    if (errors.length > 0) {
      setSnackbarMessage(errors.join("\n")); // Display errors as a list in the snackbar
      setError(true);
      setSnackbarOpen(true);
      return;
    }
    try {
      setIsSaving(true);
      let response: ApiResponse;
      
      if (pendingGoogleLocation?.source === "google") {
        const locationResult = await addMedicareLocation({
          medicareId: 0,
          providerName: pendingGoogleLocation.providerName || searchQuery,
          providerAddress: addressline1 || pendingGoogleLocation.providerAddress,
          physicalCity: city || pendingGoogleLocation.physicalCity || "",
          physicalState: state || pendingGoogleLocation.physicalState || "",
          physicalZip: zipCode || pendingGoogleLocation.physicalZip || "",
          countryName: country || pendingGoogleLocation.countryName || "USA",
          providerType: "Medicare",
          latitude: pendingGoogleLocation.latitude,
          longitude: pendingGoogleLocation.longitude,
          county: pendingGoogleLocation.county,
          telephoneNumber: "",
          faxNumber: "",
          emailId: "",
          splInstructions: instructionOption.map((opt: any) => ({
            SplInstructionID: opt.value,
            SplInstructionData: "",
          })),
          contactName: "",
          regionId: null,
          createdBy: loggedInUserid,
        }).catch((err: any) => { console.error("Failed to save Google location:", err); return null; });
        setPendingGoogleLocation(null);
      }

      const formattedFormValues = {
        AddressLine1: addressline1,
        AddressLine2: addressline2,
        AddressLine3: addressline3,
        Email: email,
        FaxNumber: faxNumber,
        PhoneNumber: phoneNumber,
        ZipCode: zipCode,
        isPrimary: isPrimary ? 1 : 0,
        IsActive: isActive ? 1 : 0,
        Comments: comments,
        AddressTypeID: addressTypeID,
        State: state,
        City: city,
        Country: country,
        County: country,
        CreatedBy: loggedInUserid,
        StakeholderId: stakeholderId,
        stakeholderaddressid: stakeholderaddressid,
      };

      if (stakeholderaddressid != "") {
        response = (await updateStackeholderAddress(
          formattedFormValues
        )) as ApiResponse;
        SelectedUserData.addressline1 = "";
        SelectedUserData.addressline2 = "";
        SelectedUserData.addressline3 = "";
        SelectedUserData.email = "";
        SelectedUserData.faxnumber = "";
        SelectedUserData.phonenumber = "";
        SelectedUserData.zipcode = "";
        SelectedUserData.isprimaryaddress = ""; // Or false if it is a boolean
        SelectedUserData.isactive = ""; // Or false if it is a boolean
        SelectedUserData.comments = "";
        SelectedUserData.addresstypeid = "";
        SelectedUserData.state = "";
        SelectedUserData.city = "";
        SelectedUserData.country = "";
        SelectedUserData.county = "";
        SelectedUserData.stakeholderaddressid = "";
        SelectedUserData.createdbyname = "";
        SelectedUserData.modifiedbyname = "";
        SelectedUserData.createddate = "";
        SelectedUserData.modifieddate = "";
      } else {
        response = (await addStackeholderAddress(
          formattedFormValues
        )) as ApiResponse;
      }
      if (response.result.responseCode == 2) {
        setSnackbarMessage("Only one primary address is allowed!");
        setError(true);
        setSnackbarOpen(true);
        setTimeout(() => {
          handlefetchAddressData();
        }, 1000);
      } else {
        setIsEditable(true);
        setStakeholderAddressId(String(response.result.id));
        setSnackbarMessage("Address saved successfully!");
        setError(false);
        setSnackbarOpen(true);

        setTimeout(() => {
          onAddressSaved();
        }, 1000);
      }
    } catch (error) {
      console.error("Error saving address:", error);
      setSnackbarMessage("An error occurred while saving the address.");
      setError(true);
      setSnackbarOpen(true);
    } finally {
      setIsSaving(false);
    }
  };

  const resetForm = () => {
    if (SelectedUserData != null) {
      setAddressLine1(SelectedUserData.addressline1);
      setAddressLine2(SelectedUserData.addressline2);
      setAddressLine3(SelectedUserData.addressline3);
      setEmail(SelectedUserData.email);
      setFaxNumber(SelectedUserData.faxnumber);
      setPhoneNumber(SelectedUserData.phonenumber);
      setZipCode(SelectedUserData.zipcode);
      setIsPrimaryAddress(SelectedUserData.isprimaryaddress);
      setIsActive(SelectedUserData.isactive);
      setComments(SelectedUserData.comments);
      setAddressTypeID(SelectedUserData.addresstypeid);
      setState(SelectedUserData.state);
      setCity(SelectedUserData.city);
      setCountry(SelectedUserData.country);
      setCounty(SelectedUserData.country);
      setstakeholderaddressid(SelectedUserData.stakeholderaddressid);
      setcreatedby(SelectedUserData.createdbyname);
      setmodifiedby(SelectedUserData.modifiedbyname);
      setcreateddate(SelectedUserData.createddate);
      setmodifieddate(SelectedUserData.modifieddate);
      const formattedCreatedDate = moment(createddate).format(
        "MM/DD/YYYY  hh:mm A"
      );
      const formattedModifiedDate = moment(modifieddate).format(
        "MM/DD/YYYY  hh:mm A"
      );

      setAddressDetails([
        {
          createdby,
          createddate: formattedCreatedDate,
          modifiedby,
          modifieddate: formattedModifiedDate,
        },
      ]);
    } else {
      setAddressLine1("");
      setAddressLine2("");
      setAddressLine3("");
      setEmail("");
      setFaxNumber("");
      setPhoneNumber("");
      setZipCode("");
      setIsPrimaryAddress(false);
      setIsActive(false);
      setComments("");
      setAddressTypeID("");
      setState("");
      setCity("");
      setCountry("");
      setCounty("");
      setSearchQuery("");
      setIsEditable(false);
      setcreatedby("");
      setmodifiedby("");
      setcreateddate("");
      setmodifieddate("");
      setSuggestionSelected(false);
      setSuggestionFilled({ city: false, state: false, country: false, zipCode: false });
      setPendingGoogleLocation(null);
    }
  };
  const handleCancel = () => {
    setShowModal(true);
  };

  const handleConfirmReset = () => {
    setShowModal(false);
    setAddressLine1("");
    setAddressLine2("");
    setAddressLine3("");
    setEmail("");
    setFaxNumber("");
    setPhoneNumber("");
    setZipCode("");
    setIsPrimaryAddress(false);
    setIsActive(false);
    setComments("");
    setAddressTypeID("");
    setState("");
    setCity("");
    setCountry("");
    setCounty("");
    setSearchQuery("");
    setIsEditable(false);
    setcreatedby("");
    setmodifiedby("");
    setcreateddate("");
    setmodifieddate("");
    setSuggestionFilled({ city: false, state: false, country: false, zipCode: false });

    onFormCancel();
  };

  const [showTooltip, setShowTooltip] = useState(false);
  const handlePDFClick = () => {
    setAddressDetails([
      {
        createdby,
        createddate,
        modifiedby,
        modifieddate,
      },
    ]);
    setShowDetails(true);
    setShowTooltip(false);
  };
  const handleCloseDrawer = () => {
    setShowDetails(false);
  };

  const addressListAccordion = (
    items: { title: string; content: JSX.Element }[]
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={addressFormKey}
      onSelect={(key) => setAddressFormKey(key as string)}
    />
  );

  const [addressDetailKey, setaddressDetailKey] = useState<string | null>("0");

  const addressDetailAccordion = (
    items: { title: string; content: JSX.Element }[]
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={addressDetailKey}
      onSelect={(key) => setaddressDetailKey(key as string)}
    />
  );

  const [communicationDetailKey, setcommunicationDetailKey] = useState<
    string | null
  >("0");

  const communicationDetailAccordion = (
    items: { title: string; content: JSX.Element }[]
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={communicationDetailKey}
      onSelect={(key) => setcommunicationDetailKey(key as string)}
    />
  );


  return (
    <>
      {!isEditable ? (
        <>
          {addressListAccordion([
            {
              title: "Address Details",
              content: (
                <>
                  <form onSubmit={handleSubmit}>
                    {addressDetailAccordion([
                      {
                        title: "Details",
                        content: (
                          <>
                            {/* Address Type */}
                            <Row className="row mb-3">
                              <Col md={3} style={{ display: "none" }}>
                                <SearchableSingleSelectDropdown
                                  label="Address Type"
                                  name="AddressTypeID"
                                  required
                                  options={typeOption}
                                  value={addressTypeID}
                                  onChange={(e) =>
                                    setAddressTypeID(e.target.value)
                                  }
                                  disabled={!editContact}
                                />
                              </Col>

                              <Col md={12}>
                                <SearchHospitalAutosuggest
                                  value={searchQuery}
                                  onChange={setSearchQuery}
                                  onSuggestionSelect={handleSuggestionSelect}
                                  label="Search Address"
                                  disabled={!editContact}
                                  maxLength={50}
                                />
                              </Col>
                            </Row>

                            {/* Address Lines */}
                            <Row className="row mb-3">
                              <Col md={6} className="mb-3">
                                <TextInput
                                  label="Address Line #1"
                                  name="AddressLine1"
                                  value={addressline1}
                                  required
                                  maxLength={100}
                                  onChange={(e) =>
                                    setAddressLine1(e.target.value)
                                  }
                                  disabled={!editContact}
                                />
                              </Col>
                              <Col md={6} className="mb-3">
                                <TextInput
                                  name="AddressLine2"
                                  label="Address Line #2"
                                  value={addressline2}
                                  maxLength={100}
                                  onChange={(e) =>
                                    setAddressLine2(e.target.value)
                                  }
                                  disabled={!editContact}
                                />
                              </Col>
                              <Col md={6}>
                                <TextInput
                                  name="AddressLine3"
                                  label="Address Line #3"
                                  value={addressline3}
                                  maxLength={100}
                                  onChange={(e) =>
                                    setAddressLine3(e.target.value)
                                  }
                                  disabled={!editContact}
                                />
                              </Col>
                            </Row>

                            {/* City, State, Country, Zip */}
                            <Row className="row mb-1">
                              <Col md={3}>
                                <TextInput
                                  label="City"
                                  name="City"
                                  value={city}
                                  maxLength={100}
                                  required
                                  onChange={(e) => setCity(e.target.value)}
                                  disabled={!editContact || !suggestionSelected || suggestionFilled.city}
                                />
                              </Col>
                              <Col md={3}>
                                <TextInput
                                  name="State"
                                  label="State"
                                  required
                                  value={state}
                                  maxLength={!editContact || !suggestionSelected || suggestionFilled.state ? 100 : 3}
                                  onChange={(e) => setState(e.target.value)}
                                  disabled={!editContact || !suggestionSelected || suggestionFilled.state}
                                />
                              </Col>
                              <Col md={3}>
                                <TextInput
                                  name="Country"
                                  label="Country"
                                  value={country}
                                  required
                                  maxLength={10}
                                  onChange={(e) => setCountry(e.target.value)}
                                  disabled={!editContact || !suggestionSelected || suggestionFilled.country}
                                />
                              </Col>
                              <Col md={3}>
                                <TextInput
                                  name="ZipCode"
                                  label="Zip Code"
                                  value={zipCode}
                                  required
                                  maxLength={!editContact || !suggestionSelected || suggestionFilled.zipCode ? 100 : 10}
                                  onChange={(e) => setZipCode(e.target.value.replace(/\D/g, ""))}
                                  disabled={!editContact || !suggestionSelected || suggestionFilled.zipCode}
                                />
                              </Col>
                            </Row>
                          </>
                        ),
                      },
                    ])}

                    {/* Phone, Email, etc. */}

                    {communicationDetailAccordion([
                      {
                        title: "Communication Details",
                        content: (
                          <>
                            <Row className="mb-3">
                              <div className="col-md-3  mb-3">
                                <FormattedPhoneInput
                                  label="Phone Number"
                                  name="Phonenumber"
                                  value={phoneNumber}
                                  onChange={setPhoneNumber}
                                  required
                                  disabled={!editContact}
                                />
                              </div>
                              <div className="col-md-3  mb-3 ">
                                <FormattedPhoneInput
                                  label="Fax No"
                                  name="Faxnumber"
                                  value={faxNumber}
                                  onChange={setFaxNumber}
                                  disabled={!editContact}
                                />
                              </div>
                              <div className="col-6"></div>
                              <div className="mt-1 mb-1">
                                <label
                                  htmlFor="isActive"
                                  className="me-2 fw-bold"
                                >
                                  Is PrimaryAddress
                                </label>
                                <input
                                  type="checkbox"
                                  checked={isPrimary}
                                  disabled={!editContact}
                                  onChange={(e) =>
                                    setIsPrimaryAddress(e.target.checked)
                                  }
                                  className="me-2"
                                />
                                {isPrimary ? <span>Yes</span> : <span>No</span>}
                              </div>
                              <div className="col-md-12  mb-3">
                                <TextInput
                                  name="Comments"
                                  label="Comments"
                                  value={comments}
                                  maxLength={100}
                                  onChange={(e) => setComments(e.target.value)}
                                  disabled={!editContact}
                                />
                              </div>
                              <div className="mt-3">
                                <label
                                  htmlFor="isActive"
                                  className="me-2 fw-bold"
                                >
                                  Is Active
                                </label>
                                <input
                                  type="checkbox"
                                  id="isActive"
                                  checked={isActive}
                                  disabled={!editContact}
                                  onChange={(e) =>
                                    setIsActive(e.target.checked)
                                  }
                                  className="me-2"
                                />
                                {isActive ? <span>Yes</span> : <span>No</span>}
                              </div>
                            </Row>
                          </>
                        ),
                      },
                    ])}

                    <Row className="mt-3">
                      <Col sm={6} className="d-flex justify-content-start">
                        <OverlayTrigger
                          show={showTooltip}
                          placement="auto"
                          trigger={["hover", "focus"]} // Important to prevent sticky tooltip
                          delay={{ show: 200, hide: 100 }}
                          overlay={
                            <Tooltip style={{ backgroundColor: "#b3e0ff" }}>
                              Logs
                            </Tooltip>
                          }
                        >
                          <div className="d-flex">
                            <button
                              type="button"
                              className="btn btn-primary d-flex align-items-center"
                              onClick={handlePDFClick}
                              onMouseEnter={() => setShowTooltip(true)}
                              onMouseLeave={() => setShowTooltip(false)}
                            >
                              <span className="material-icons">
                                description
                              </span>
                            </button>
                          </div>
                        </OverlayTrigger>
                        <button
                          className="btn d-flex align-items-center btn-text-border me-2 mx-2"
                          onClick={handleConfirmReset}
                        >
                          <span className="material-icons">arrow_back</span>
                          Back
                        </button>
                      </Col>
                      <Col sm={6} className="d-flex  justify-content-end">
                        <div>
                          {editContact && (
                            <button
                              type="button"
                              className="btn d-flex align-items-center btn-text"
                              onClick={handleCancel}
                            >
                              <span className="material-icons mr-2">close</span>
                              Cancel
                            </button>
                          )}
                        </div>
                        {editContact && (
                          <button
                            type="submit"
                            className="btn btn-primary ml-3 d-flex align-items-center"
                            disabled={isSaving}
                          >
                            <span className="material-icons mx-1">save</span>
                            Save
                          </button>
                        )}
                      </Col>
                      <ConfirmationModal
                        show={showModal}
                        handleClose={() => setShowModal(false)}
                        handleConfirm={handleConfirmReset}
                        message="Are you sure you want to reset the form?"
                      />
                    </Row>
                  </form>
                </>
              ),
            },
          ])}
          <OverlayDrawer
            title={"Logs"}
            open={showDetails}
            onClose={handleCloseDrawer}
            placement="bottom"
          >
            <DataTable
              headers={STAKEHOLDER_LOG_ADDRESS}
              rows={addressDetails}
              isLogTable={true}
            />
          </OverlayDrawer>
        </>
      ) : (
        <StackHolderAddressList />
      )}

      {/* Snackbar for success/error */}
      <Snackbar
        open={snackbarOpen}
        message={snackbarMessage}
        onClose={() => setSnackbarOpen(false)}
        severity={error ? "error" : "success"}
      />
    </>
  );
};

export default AddNewUser;
